import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

import pt from 'vuetify/es5/locale/pt'

const opts = {
    lang: {
        locales: { pt },
        current: 'pt',
    },
}

export default new Vuetify(opts)
